// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2a8oR","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3-XSd","obliqueLine":"membershipbadge_obliqueLine__3HcN9"};